import { Component, OnInit, Input, Output, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { GridTableParametersService } from './../../../../template/gridTemplate/gridTableParameters.service';

import { FromPicklistPipe } from 'src/app/shared/pipes/fromPicklistPipe.pipe';
import { ToPicklistPipe } from 'src/app/shared/pipes/toPicklistPipe.pipe';

import { FormularService } from 'src/app/Services/formular.service';
import { newArray } from '@angular/compiler/src/util';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthentService, AuthenticationRole } from 'src/app/Services/authent.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-new-req-form',
  templateUrl: './new-req-form.component.html',
  styleUrls: ['./new-req-form.component.css'],
})
export class NewReqFormComponent implements OnInit, OnDestroy {
  @Input() public childFormInput: FormGroup;
  @Output() public submitFormular = new EventEmitter();
  
  // Language;
  resourceDefinition;
  Picklist;
  User;
  formular;
  showLoading = true;
  gipDefault;
  currentRequestUser;

  constructor(public fb: FormBuilder,
    private shareData: SharingDataService,
    public grid: GridTableParametersService,
    public toPicklist: ToPicklistPipe,
    public fromPicklist: FromPicklistPipe,
    public formularService: FormularService,
    public dialog: MatDialog,
    private router: Router,
    public authService: AuthentService,
    public datePipe: DatePipe,
  ) { }

  ngOnDestroy(): void {
    this.childFormInput.controls.END_ACTIVITY_DT.setValidators(null);
    this.childFormInput.controls.BEGIN_ACTIVITY_DT.setValidators(null);
  }

  formularEx = [
    {formControlName : "ACTIVITY_TYPE",                   picklist: "V_MS_ACTIVITY_TYPE_VL_T",  autocomplete: null,    required: true,    readonly : false,   datepicker: false,   datepickerType: null,            datepickerMax : null,     datepickerMin : null,         datepickerMaxVariable: null,                  datepickerMinVariable: null,                  function: "onSubmit",   textArea: false,    checkbox: false,  title: "cptn_DefineRequest"},
    {formControlName : "REASON_TYPE",                     picklist: "V_MS_REASON_TYPE_VL_T",    autocomplete: null,    required: true,    readonly : false,   datepicker: false,   datepickerType: null,            datepickerMax : null,     datepickerMin : null,         datepickerMaxVariable: null,                  datepickerMinVariable: null,                  function: "onSubmit",   textArea: false,    checkbox: false,  title: null},
    {formControlName : "BEGIN_ACTIVITY_DT", newRow: true,                                       autocomplete: null,    required: true,    readonly : false,   datepicker: true,    datepickerType: "formatFrom",    datepickerMax : null,     datepickerMin : new Date(),   datepickerMaxVariable: "END_ACTIVITY_DT",     datepickerMinVariable: null,                  function: "",           textArea: false,    checkbox: false,  title: null},
    {formControlName : "END_ACTIVITY_DT",                                                       autocomplete: null,    required: true,    readonly : false,   datepicker: true,    datepickerType: "formatTo",      datepickerMax : null,     datepickerMin : null,         datepickerMaxVariable: null,                  datepickerMinVariable: "BEGIN_ACTIVITY_DT",   function: "",           textArea: false,    checkbox: false,  title: null},
    {formControlName : "LOCATION_DESC",                                                         autocomplete: null,    required: true,    readonly : false,   datepicker: false,   datepickerType: null,            datepickerMax : null,     datepickerMin : null,         datepickerMaxVariable: null,                  datepickerMinVariable: null,                  function: "onSubmit",   textArea: true,     checkbox: false,  title: "cptn_Description"},
    {formControlName : "RESPONSIBLE_PERSON",                                                    autocomplete: null,    required: false,   readonly : true,    datepicker: false,   datepickerType: null,            datepickerMax : null,     datepickerMin : null,         datepickerMaxVariable: null,                  datepickerMinVariable: null,                  function: "",           textArea: false,    checkbox: false,  title: "cptn_Responsibility"},
    {formControlName : "RESPONSIBLE_PERSON_TEL_NUM",                                            autocomplete: null,    required: false,   readonly : true,    datepicker: false,   datepickerType: null,            datepickerMax : null,     datepickerMin : null,         datepickerMaxVariable: null,                  datepickerMinVariable: null,                  function: "",           textArea: false,    checkbox: false,  title: null},
  ]

  formularIn = [
    // {formControlName : "PERSON_ID",     required: true,  modalWindow: true, readonly : false, function: "personIdModalWindow",  title: "cptn_RequestFor"},
    {formControlName : "FULLNAME",     required: true,  modalWindow: true, readonly : false, function: "personIdModalWindow",  title: "cptn_RequestFor"},
    // {formControlName : "FULLNAME",     required: true,  inputString: true, readonly : true},
    {formControlName : "CONTRACT_NAME",     required: true,  picklist: "V_MS_CONTRACT_VL", readonly : true},
    {formControlName : "RESPONSIBLE_PERSON",                                                    required: false,   readonly : true,   title: "cptn_Responsibility"},
    {formControlName : "RESPONSIBLE_PERSON_TEL_NUM",                                            required: false,   readonly : true},
    {formControlName : "ACTIVITY_TYPE",                   picklist: "V_MS_ACTIVITY_TYPE_VL_T",  required: true,    readonly : false,       function: "onSubmit",    title: "cptn_DefineRequest"},
    {formControlName : "REASON_TYPE",                     picklist: "V_MS_REASON_TYPE_VL_T",    required: true,    readonly : false,       function: "onSubmit",    title: null},
    {formControlName : "BEGIN_ACTIVITY_DT", newRow: true,        datepickerMaxVariable: "END_ACTIVITY_DT",          required: true,    readonly : false,   datepicker: true,    datepickerType: "formatFrom",    datepickerMax : null,     datepickerMin : new Date()},
    {formControlName : "END_ACTIVITY_DT",         datepickerMinVariable: "BEGIN_ACTIVITY_DT",   required: true,    readonly : false,   datepicker: true,    datepickerType: "formatTo",      datepickerMax : null,     datepickerMin : null },
    {formControlName : "LOCATION_DESC",                                                         required: true,    readonly : false,      datepickerType: null,                function: "onSubmit",   textArea: true,  title: "cptn_Description"},
    {formControlName : "INTNOTE",   required: false,   textArea : true, title: "cptn_InternalCommunication"},
  ]

  action(action){
    this[action]();
  }

  onSubmit() {
    this.submitFormular.emit();
  }

  ngOnInit(): void {
    this.shareData.changeCurrentRequestUser(null);
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentPicklist.subscribe(data => this.Picklist = data);
    this.shareData.currentGipDefault.subscribe(data => this.gipDefault = data);
    this.shareData.currentRequestUser.subscribe(data => this.currentRequestUser = data);

    this.childFormInput.reset();
    this.childFormInput.controls.DELIVERY_STATE.setValue("0");
    this.childFormInput.controls.REQUEST_STATE.setValue("0");
    // this.childFormInput.controls.REQERR_NOTIF.setValue(this.translateText.transform("RECAPTCHAENABLED", this.gipDefault, "GIP_NAME", "GIP_VALUE"));
    this.shareData.currentUser.subscribe(data => {
      if(data != null){
        this.User = data;
        this.childFormInput.controls.REQUEST_DT.setValue(this.datePipe.transform(new Date(), "yyyy-MM-ddTHH:mm:ssZ").substring(0,22) + ":" + this.datePipe.transform(new Date(), "yyyy-MM-ddTHH:mm:ssZ").substring(22));
        this.childFormInput.controls.REQUESTOR.setValue(this.User.USERGUID);
        this.childFormInput.controls.COMPANY.setValue(this.User.COMPANY_NAME);
        if (this.authService.currentUser().ROLE == AuthenticationRole.ExternalAdmin || this.authService.currentUser().ROLE == AuthenticationRole.ExternalUser || this.authService.currentUser().ROLE == AuthenticationRole.Public) {
          this.externalOnInit();
        }
        if (this.authService.currentUser().ROLE == AuthenticationRole.InternalAdmin || this.authService.currentUser().ROLE == AuthenticationRole.InternalUser) {
          this.internalOnInit();
        }
      }
    });
  }

  externalOnInit(){
    this.childFormInput.controls.FULLNAME.setValue(`${this.User.NAME} ${this.User.SURNAME}`);
    this.childFormInput.controls.RESPONSIBLE_PERSON.setValue(`${this.User.NAME} ${this.User.SURNAME}`);
    this.childFormInput.controls.RESPONSIBLE_PERSON_TEL_NUM.setValue(this.User.PHONE);
    this.formular = this.formularEx;
    this.childFormInput.controls.PERSON_ID.setValue(this.User.USERGUID);
    this.externalGetData();
  }

  internalOnInit(){
    this.formular = this.formularIn;
    this.internalGetData();
  }

  externalGetData() {
    this.childFormInput.controls.PERSON_EMAIL.setValue(this.User.EMAIL);
    var urls = [
      `admin/MS_CONTRACT?$filter=ID eq ${this.User.CONTRACT}`,
      `admin/MS_COMPANY?$filter=MID eq ${this.User.COMPANY_MID}`
    ]

    this.formularService.getData(urls, (data) => {
      const contract = data[0][0];
      const company = data[1][0];
      this.childFormInput.controls.BEGIN_ACTIVITY_DT.setValue(this.datePipe.transform(new Date(), "yyyy-MM-ddTHH:mm:ssZ").substring(0,22) + ":" + this.datePipe.transform(new Date, "yyyy-MM-ddTHH:mm:ssZ").substring(22))
      this.childFormInput.controls.END_ACTIVITY_DT.setValue(contract.CONTRACT_EXPIRATION_DT);
      this.setDateMaxMin();
      var date = new Date();
      date.setDate(date.getDate() + contract.REQ_EXPIRATION_TIME)
      this.childFormInput.controls.EXPIRATION_DT.setValue(this.datePipe.transform(date, "yyyy-MM-ddTHH:mm:ssZ").substring(0,22) + ":" + this.datePipe.transform(new Date(), "yyyy-MM-ddTHH:mm:ssZ").substring(22));
      var isCompanyLocked = company.UNUSED === 1 ? true : false;
      this.showLoading = false;
      if(new Date(this.childFormInput.value.END_ACTIVITY_DT) < new Date() || isCompanyLocked){
        this.router.navigate([""]);
      }
    })
  }

  internalGetData() {
    this.childFormInput.controls.BEGIN_ACTIVITY_DT.setValue(this.datePipe.transform(new Date(), "yyyy-MM-ddTHH:mm:ssZ").substring(0,22) + ":" + this.datePipe.transform(new Date, "yyyy-MM-ddTHH:mm:ssZ").substring(22))
    this.setDateMaxMin();
    this.showLoading = false;
  }

  dateChange(date){
    if (date.type == "formatFrom") {
      this.childFormInput.controls.BEGIN_ACTIVITY_DT.setValue(date.value);
    } else if (date.type == "formatTo"){
      this.childFormInput.controls.END_ACTIVITY_DT.setValue(date.value);
    }
    this.setDateMaxMin();
  }

  setDateMaxMin(){
    this.formular.forEach(element => {
      if(element.formControlName == "BEGIN_ACTIVITY_DT" && this.childFormInput.value.END_ACTIVITY_DT != null){
        element.datepickerMax = this.childFormInput.value.END_ACTIVITY_DT;
      }
      if(element.formControlName == "END_ACTIVITY_DT" && this.childFormInput.value.BEGIN_ACTIVITY_DT != null){
        element.datepickerMin = this.childFormInput.value.BEGIN_ACTIVITY_DT;
      }
    });
  }

  personIdModalWindow(){
    const dialogRef = this.dialog.open(personIdDialog, {
      data: {user : this.currentRequestUser}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined){
        this.shareData.changeCurrentRequestUser(result);
        const selectedRow = result;
        this.childFormInput.controls.FULLNAME.setValue(selectedRow.FULLNAME);
        this.childFormInput.controls.CONTRACT_NAME.setValue(selectedRow.CONTRACT);
        this.childFormInput.controls.PERSON_ID.setValue(selectedRow.USERGUID);
        this.childFormInput.controls.COMPANY.setValue(selectedRow.COMPANY_NAME);
        this.childFormInput.controls.PERSON_EMAIL.setValue(selectedRow.EMAIL);
        this.childFormInput.controls.RESPONSIBLE_PERSON.setValue(`${selectedRow.NAME} ${selectedRow.SURNAME}`);
        this.childFormInput.controls.RESPONSIBLE_PERSON_TEL_NUM.setValue(selectedRow.PHONE);

        this.showLoading = true;
        this.formularService.getData([`admin/MS_CONTRACT?$filter=ID eq ${selectedRow.CONTRACT}`, `admin/MS_COMPANY?$filter=MID eq ${selectedRow.COMPANY_MID}`], (data) => {
          this.childFormInput.controls.END_ACTIVITY_DT.setValue(data[0][0].CONTRACT_EXPIRATION_DT);
          const date = new Date();
          date.setDate(date.getDate() + data[0][0].REQ_EXPIRATION_TIME)
          this.childFormInput.controls.EXPIRATION_DT.setValue(this.datePipe.transform(date, "yyyy-MM-ddTHH:mm:ssZ").substring(0,22) + ":" + this.datePipe.transform(date, "yyyy-MM-ddTHH:mm:ssZ").substring(22));
          const obj: any = {};
          if (new Date(this.childFormInput.value.END_ACTIVITY_DT) < new Date()) {
            obj.expirationDate = true;
          }
          if (data[1][0].UNUSED === 1) {
            obj.companyLocked = true;
          }
          if (result.VERIFIED === '0') {
            obj.notVerified = true;
          }
          if (result.LOCKED === '1') {
            obj.locked = true;
          }
          if (Object.keys(obj).length !== 0 || obj.constructor !== Object) {
            this.childFormInput.controls.FULLNAME.setErrors(obj);
          }
          this.showLoading = false;
        })
      }
    });
  }
}

@Component({
  selector: 'personIdDialog',
  templateUrl: 'personIdDialog.html',
})
export class personIdDialog {
  resourceDefinition;
  selectedRow;
  selectedRows;
  PersonIDGrid;
  selectedKey="USERGUID";
  groupName="V_MS_USER";
  authRole = AuthenticationRole;


  constructor(
    private shareData: SharingDataService,
    public dialogRef: MatDialogRef<personIdDialog>,
    private authService: AuthentService,
    @Inject(MAT_DIALOG_DATA) public data
    ) {
      shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
      this.selectedRow = data.user?.USERGUID;

    this.PersonIDGrid = [
      {name: "select",        visible: true,   enableFilter: false, enableOrderBy: false,   export : false,   type : "singleSelect",  enableSelect: true,   columnSearch : false,  fromToFilter : false,   picklistTableName : null,                function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
      {name: "USERGUID",      visible: false,  enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,                function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
      {name: "TITLE",         visible: true,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,                function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
      {name: "NAME",          visible: true,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,                function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
      {name: "SURNAME",       visible: true,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,                function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
      {name: "FULLNAME",      visible: false,  enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,                function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
      {name: "EMAIL",         visible: true,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,                function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
      {name: "PHONE",         visible: false,  enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,                function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
      {name: "CONTRACT",      visible: true,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "picklistText",  enableSelect: true,   columnSearch : false,  fromToFilter : false,   picklistTableName : "V_MS_CONTRACT_VL",  function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
      {name: "COMPANY_MID",   visible: true,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "picklistText",  enableSelect: true,   columnSearch : false,  fromToFilter : false,   picklistTableName : "V_MS_COMPANY_VL",   function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
      { name: "LOCKED", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "checkboxText", columnSearch: false, fromToFilter: false, picklistTableName: "V_GIP_NUMBOOL_VL_T", function: "toUserPage", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
      { name: "COMPANY_UNUSED", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "checkbox", columnSearch: false, fromToFilter: false, picklistTableName: "V_GIP_NUMBOOL_VL_T", function: 'toCompanyPage', CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
      {name: "CONTRACT_EXP",  visible: false,  enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,                function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
      ]
    }

    urlString = "data/V_MS_USER";
    defaultOrderby = [["SURNAME"],["up"]];
    defaultFilter = `ROLES ne '${this.authRole.InternalAdmin}' and ROLES ne '${this.authRole.InternalUser}'`

    action(parameters){
      this[parameters.action](parameters.element, parameters.column, parameters.selectedSingleRows, parameters.selectedMultiRows);
    }

    Select(element, column, selectedSingleRows, selectedMultiRows){
      this.selectedRows = selectedSingleRows;
    }

    close(){
      this.dialogRef.close();
    }

}
